import { CircularProgress } from '@material-ui/core';
import React from 'react';

import { Div } from '~/src/dash/publicaUI';

export const LoadingChart = () => {
  return (
    <Div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      Loading Query... <CircularProgress size={14} />
    </Div>
  );
};
